import React, { useEffect, useMemo } from 'react';
import home_img from '../images/web-dev.svg';
import home_img_1 from '../images/home_1.png';
import home_img_2 from '../images/home_2.png';
const Home = () => {
    const words = useMemo(() => ["Innovation", "Scalability", "Digital Transformation", "Growth"], []);
    const [text, setText] = React.useState("");
    const [index, setIndex] = React.useState(0);
    const [subIndex, setSubIndex] = React.useState(0);
    const [deleting, setDeleting] = React.useState(false);
    const images = [home_img, home_img_1, home_img_2];
    const [imgIndex, setImgIndex] = React.useState(0);

    useEffect(() => {
        if (index === words.length) setIndex(0);

        if (
            subIndex === words[index].length + 1 &&
            !deleting
        ) {
            setTimeout(() => setDeleting(true), 1500);
            return;
        }

        if (subIndex === 0 && deleting) {
            setDeleting(false);
            setIndex((prev) => (prev + 1) % words.length);
            return;
        }

        const timeout = setTimeout(() => {
            setSubIndex((prev) => prev + (deleting ? -1 : 1));
        }, deleting ? 50 : 120);

        return () => clearTimeout(timeout);
    }, [subIndex, index, deleting, words]);

    useEffect(() => {
        setText(words[index].substring(0, subIndex));
    }, [subIndex, index, words]);

    React.useEffect(() => {
        const imgTimer = setInterval(() => {
            setImgIndex((prev) => (prev + 1) % images.length);
        }, 3000);
        return () => clearInterval(imgTimer);
    }, [images.length]);

    return (
        <section className="home hero-section position-relative pb-5" id="home">
            <div className="hero-overlay"></div>
            <div className="hero-particles"></div>
            <div className="container overflow-hidden mt-8 mt-lg-4 p-2 p-md-12" data-aos="zoom-in">
                <div className="row py-8 text-center text-lg-start align-items-center">
                    <div className="col-lg-8 d-flex flex-column justify-content-center hero-text" data-aos="zoom-in" data-aos-delay="200">
                        <div className="hero-text">
                            <h1 className="display-4 fw-bold mt-4 mb-2 futuristic-text">
                                Empowering Businesses with
                            </h1>
                            <h1 className="display-4 fw-bold mb-2 futuristic-text">
                                <span className="highlighted-word">{text}</span>
                                <span className="blinking-cursor">|</span>
                            </h1>
                            <p className="lead mb-5 futuristic-subtext">
                                We design and build scalable software, web, and mobile solutions that help businesses grow smarter and faster.
                            </p>
                            <a href="#about" className="btn btn-gradient btn-lg rounded-pill shadow-lg">
                                Learn More
                            </a>
                        </div>
                    </div>
                    <div className="col-lg-4 d-flex justify-content-lg-end" data-aos="fade-up" data-aos-delay="700">
                        <div className="hero-image-wrapper">
                            <div className="hero-image-glow"></div>
                            <img
                                alt="card img"
                                className="rounded float-end w-100 img-border img-3d"
                                src={images[imgIndex]}
                                style={{ transition: 'opacity 0.6s' }}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Home;
